import React, {useState} from 'react';
import {
    Box,
    Container,
    Drawer,
    IconButton,
    List,
    ListItemButton, ListItemIcon,
    ListItemText,
    MenuItem,
    Toolbar,
    Typography
} from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from '@mui/icons-material/Person';
import {Link} from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import "@fontsource/roboto-mono";
import useMediaQuery from '@mui/material/useMediaQuery';
import Logo from "./Logo";


const DefaultAppBar = (props) => {
    let fixed = props.fixed;
    let transparent = props.transparent;
    const pages = [
        // {title: 'Service', url: '/service', icon: <CarpenterIcon/>},
        // {title: 'News', url: '/news', icon: <NewspaperIcon/>},
        {title: 'Impressum', url: '/impressum', icon: <PersonIcon/>},
    ];
    const [drawerOpen, setDrawerOpen] = useState(false);
    const isDesktop = useMediaQuery('(min-width:900px)');
    return (
        <Box>
            <AppBar position={fixed ? 'fixed' : 'sticky'}
                    style={{background: transparent ? 'rgba(0, 0, 0, 0.65)' : '#5d625d', boxShadow: 'none'}}>
                {!isDesktop && (<Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{mr: 2}}
                        onClick={() => setDrawerOpen(true)}
                    >
                        <MenuIcon/>
                    </IconButton>
                </Toolbar>)}
                <Container maxWidth="xl">
                    {isDesktop && (<Toolbar disableGutters>
                        <Logo/>
                        {
                            pages.map((page) => (
                                <Box key={page.url} sx={{mx: 0.5}}>
                                    <MenuItem component={Link} to={page.url} style={{borderRadius: 6}}>
                                        <Typography textAlign="center">{page.title}</Typography>
                                    </MenuItem>
                                </Box>
                            ))
                        }
                    </Toolbar>)}
                </Container>
            </AppBar>
            {
                !isDesktop && (<Drawer
                    anchor='left'
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}>
                    {
                        <List style={{width: '16em'}}>
                            <ListItemButton component={Link} to='/'>
                                <ListItemIcon>
                                    <HomeIcon/>
                                </ListItemIcon>
                                <ListItemText>Home</ListItemText>
                            </ListItemButton>
                            {
                                pages.map((page) => (
                                    <ListItemButton component={Link} to={page.url}>
                                        <ListItemIcon>
                                            {page.icon}
                                        </ListItemIcon>
                                        <ListItemText>{page.title}</ListItemText>
                                    </ListItemButton>
                                ))
                            }
                        </List>
                    }
                </Drawer>)
            }
        </Box>
    );
};

export default DefaultAppBar;
